// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"c42a2501","192":"e56a38e3","217":"2cb01258","333":"60224257","358":"433d224e","367":"3357c66a","385":"75244c1b","452":"e345144e","624":"451e2368","651":"df887337","766":"61dac832","771":"9aef674e","956":"39b9a9dd"}[chunkId] + ".chunk.js";
};